module.exports = __webpack_public_path__ + "img/404.e4d638fd.png";